import React, {useState} from 'react';
import {Button, SvgIcon, Tab, Tabs} from "@mui/material";
import EstablishmentCreateUpdateForm from "../EstablishmentAddView/EstablishmentCreateUpdateForm";
import localStrings from "../../../localStrings";
import {MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {getUriSetting, saveUriSetting, SELECTED_TAB} from "../../../utils/optionsUriLocalStorage";
import useAuth from "../../../hooks/useAuth";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {Link as RouterLink} from "react-router-dom";
import {
    boardsRoute,
    dashboardBaseRoute,
    establishmentListRoute,
    restaurantAddRoute,
    restaurantListRoute
} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Integration from "./Integration";
import RhMapping from "./rhMapping";

const EstablishmentDetailsView = () => {
  const {currentBrand} = useAuth()
  const [currentTab, setCurrentTab] = useState(getUriSetting(SELECTED_TAB) || 'general');



  const searchParams = new URLSearchParams(window.location.search);
  const urlBack = searchParams.get('urlBack');
  const urlBackTitle = searchParams.get('urlBackTitle');

  const handleTabsChange = (event, value) => {
    saveUriSetting(SELECTED_TAB, value)
    setCurrentTab(value);
  };

  function getMainButtons() {
    return (
      <>
        {urlBack && urlBackTitle &&
          <RouterLink to={decodeURI(urlBack)}
                      style={{ textDecoration: 'none' }}
          >
            <Button
              color="primary"
              variant="contained"
              startIcon={(
                <SvgIcon>
                  <ArrowBackIcon />
                </SvgIcon>
              )}
            >
              {urlBackTitle}
            </Button>
          </RouterLink>
        }
        <RouterLink to={'/' + dashboardBaseRoute + '/' + establishmentListRoute}
                    style={{ textDecoration: 'none' }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={(
              <SvgIcon>
                <ArrowBackIcon />
              </SvgIcon>
            )}
          >
            {localStrings.backToList}
          </Button>
        </RouterLink>
      </>
    )
  }

  return (
    <PageWithTitle title={localStrings.establishment} mainButtons={getMainButtons()}>
      {/*{brandGetEnoughCredits(currentBrand()) ?*/}
        <>

          <Tabs
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={currentTab}
            textColor="secondary"
            variant="scrollable"
          >
            <Tab label={localStrings.general} value="general"/>
            <Tab label={localStrings.integration} value="integration"/>
            <Tab label={localStrings.rhMapping} value="rhMapping"/>

          </Tabs>
          {currentTab === 'general' && <EstablishmentCreateUpdateForm modeEdit={MODE_EDIT}/>}
          {currentTab === 'integration' && <Integration/>}
          {currentTab === 'rhMapping' && <RhMapping/>}
        </>
    </PageWithTitle>
  );
};

export default EstablishmentDetailsView;
